import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Card.scss';

export default class Card extends Component {
  static propTypes = {
    'className': PropTypes.string,
    'children': PropTypes.node,
    'onClick': PropTypes.func,
    'data-test': PropTypes.string
  };

  render() {
    const {
      className,
      children,
      onClick,
      'data-test': dataTestId = 'card'
    } = this.props;
    const classComponent = classNames('card__item', className);

    return (
      <div className={classComponent} onClick={onClick} data-test={dataTestId}>
        {children}
      </div>
    );
  }
}
